import React from 'react';
import './select-input.css';

export interface IOption {
    value: any;
    text: string;
    disabled?: boolean;
}

interface ISelectInputProps {
    name: string;
    label?: string;
    options: any[];
    className: string;
    onChange?: (event: React.ChangeEvent<any>) => void;
    hasDefaultOption?: boolean;
    defaultOption?: string;
    value?: string | number;
    error?: string;
    required?: boolean;
    labelClassName?: string;
    fieldClassName?: string;
    disabled?: boolean;
    inlineStyle?: object;
    customLabel?: boolean;
}

const SelectInputModal = ({
    name,
    options,
    onChange,
    hasDefaultOption,
    defaultOption,
    value,
    error,
    className,
    disabled,
    inlineStyle,
}: ISelectInputProps) => {
    return (
        <>
            <select
                name={name}
                value={(value = value || value === 0 ? value : defaultOption)}
                onChange={onChange}
                className={className}
                disabled={disabled}
                style={inlineStyle}
            >
                {hasDefaultOption && <option value="">{defaultOption}</option>}
                {options.map((option, i) => {
                    if (option)
                        return (
                            <option
                                key={
                                    // new 'no receiver' option caused NaN error, so added this workaround for now
                                    isNaN(option.value)
                                        ? 'NaN' + i.toString()
                                        : option.value + i.toString()
                                }
                                value={option.value.toString()}
                                disabled={option.disabled ? true : false}
                            >
                                {option.text}
                            </option>
                        );
                })}
            </select>
            {error && <div className="alert alert-danger">{error}</div>}
        </>
    );
};

export default SelectInputModal;
